import { render, staticRenderFns } from "./RedirectToPartner.vue?vue&type=template&id=7601029e&scoped=true&"
import script from "./RedirectToPartner.vue?vue&type=script&lang=js&"
export * from "./RedirectToPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7601029e",
  null
  
)

export default component.exports